module.exports = __webpack_public_path__ + "img/icon_successful_payment@2x.986a4d2e.png";